var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNamedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 23,
    viewBox: "0 0 165 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.064 0.24704V22.6498H14.4322V13.0001H4.63179V22.6498H0V0.24704H4.63179V9.75779H14.4322V0.24704H19.064Z",
    fill: "url(#paint0_linear_1_407)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.0849 22.6498H43.5114C43.1126 22.6498 42.7867 22.5533 42.5375 22.3642C42.2882 22.175 42.1003 21.928 41.9776 21.6308L40.4746 17.354H31.6098L30.1068 21.6308C30.0032 21.8894 29.8269 22.121 29.57 22.3333C29.3131 22.5456 28.991 22.6498 28.6037 22.6498H24.9995L33.6956 0.24704H38.4041L47.0849 22.6498ZM39.355 14.1426L36.9471 7.28746C36.8052 6.92849 36.6519 6.5039 36.4946 6.02142C36.3374 5.53893 36.1841 5.01399 36.0422 4.44659C35.9003 5.02171 35.747 5.55437 35.5898 6.04457C35.4326 6.53478 35.2792 6.95937 35.1373 7.31834L32.7447 14.1426H39.355Z",
    fill: "url(#paint1_linear_1_407)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M66.463 18.8825V22.6498H53.2578V0.24704H57.8589V18.8825H66.463Z",
    fill: "url(#paint2_linear_1_407)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M93.4717 11.4407C93.4717 13.0773 93.1995 14.5942 92.6512 15.9953C92.1029 17.3965 91.3322 18.6046 90.3353 19.6236C89.3384 20.6426 88.1383 21.4416 86.7388 22.0245C85.3393 22.6073 83.7826 22.8968 82.0763 22.8968C80.3701 22.8968 78.8133 22.6073 77.4138 22.0245C76.0143 21.4416 74.8104 20.6426 73.8096 19.6236C72.8089 18.6046 72.0344 17.3965 71.4861 15.9953C70.9378 14.5942 70.6655 13.0773 70.6655 11.4407C70.6655 9.80409 70.9378 8.28716 71.4861 6.89374C72.0344 5.50032 72.8089 4.29218 73.8096 3.27317C74.8104 2.25416 76.0143 1.45517 77.4138 0.872325C78.8133 0.289483 80.3701 0 82.0763 0C83.7826 0 85.3393 0.289483 86.7388 0.872325C88.1383 1.45517 89.3384 2.25803 90.3353 3.2809C91.3322 4.30377 92.1029 5.51576 92.6512 6.90918C93.1995 8.3026 93.4717 9.81181 93.4717 11.4407ZM88.7633 11.4407C88.7633 10.2673 88.6099 9.21353 88.3032 8.2833C87.9964 7.35307 87.5555 6.55793 86.9765 5.90561C86.3975 5.25329 85.6997 4.7515 84.8753 4.40798C84.051 4.06445 83.1192 3.89075 82.0763 3.89075C81.0334 3.89075 80.0978 4.06445 79.2696 4.40798C78.4414 4.7515 77.7398 5.25329 77.1608 5.90561C76.5818 6.55793 76.1409 7.35307 75.8341 8.2833C75.5274 9.21353 75.374 10.2673 75.374 11.4407C75.374 12.6257 75.5274 13.6833 75.8341 14.6135C76.1409 15.5437 76.5818 16.335 77.1608 16.9835C77.7398 17.6319 78.4414 18.1298 79.2696 18.4734C80.0978 18.8169 81.0334 18.9906 82.0763 18.9906C83.1192 18.9906 84.051 18.8169 84.8753 18.4734C85.6997 18.1298 86.3975 17.6319 86.9765 16.9835C87.5555 16.335 87.9964 15.5437 88.3032 14.6135C88.6099 13.6794 88.7633 12.6218 88.7633 11.4407Z",
    fill: "url(#paint3_linear_1_407)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M102.444 6.56179C102.609 5.46945 102.916 4.5122 103.364 3.69004C103.813 2.86789 104.376 2.18083 105.051 1.63658C105.726 1.09234 106.497 0.683198 107.36 0.409146C108.222 0.135095 109.158 0 110.159 0C111.221 0 112.175 0.150532 113.019 0.455463C113.862 0.760393 114.576 1.1734 115.158 1.69834C115.741 2.22329 116.19 2.837 116.5 3.53564C116.811 4.23428 116.968 4.98696 116.968 5.78982C116.968 6.50004 116.895 7.12533 116.746 7.66571C116.596 8.2061 116.378 8.677 116.086 9.07843C115.795 9.47986 115.438 9.81952 115.013 10.0974C114.587 10.3753 114.1 10.6069 113.548 10.7922C116.106 11.6375 117.382 13.3513 117.382 15.9336C117.382 17.0761 117.171 18.0835 116.753 18.952C116.336 19.8205 115.772 20.55 115.066 21.1367C114.361 21.7234 113.54 22.1634 112.605 22.4568C111.669 22.7501 110.692 22.8968 109.668 22.8968C108.583 22.8968 107.628 22.7733 106.8 22.5262C105.972 22.2792 105.243 21.9087 104.614 21.4146C103.985 20.9205 103.445 20.2991 102.996 19.5541C102.548 18.8092 102.153 17.9368 101.815 16.9371L103.686 16.1652C104.177 15.9606 104.633 15.9027 105.059 15.9953C105.485 16.088 105.787 16.3157 105.972 16.6747C106.175 17.0645 106.393 17.4274 106.623 17.7554C106.853 18.0835 107.11 18.3692 107.398 18.6123C107.685 18.8555 108.008 19.0408 108.372 19.1759C108.736 19.311 109.15 19.3766 109.622 19.3766C110.216 19.3766 110.73 19.2801 111.171 19.0832C111.612 18.8864 111.98 18.6316 112.275 18.319C112.57 18.0063 112.793 17.6512 112.942 17.2537C113.092 16.8561 113.165 16.4624 113.165 16.0725C113.165 15.5592 113.119 15.0921 113.027 14.6753C112.935 14.2584 112.724 13.9033 112.39 13.6099C112.057 13.3166 111.566 13.0889 110.918 12.9306C110.27 12.7723 109.388 12.6913 108.272 12.6913V9.69601C109.204 9.69601 109.963 9.61881 110.557 9.46442C111.152 9.31002 111.616 9.09387 111.953 8.81596C112.29 8.53805 112.524 8.20224 112.651 7.81239C112.777 7.42254 112.843 6.99409 112.843 6.53091C112.843 5.55436 112.589 4.80555 112.083 4.29218C111.577 3.77882 110.86 3.52021 109.928 3.52021C109.518 3.52021 109.142 3.5781 108.801 3.69776C108.46 3.81742 108.153 3.97953 107.881 4.18411C107.609 4.38868 107.379 4.63186 107.183 4.90977C106.988 5.18768 106.846 5.4926 106.754 5.82069C106.558 6.33406 106.309 6.67759 106.002 6.84742C105.695 7.01726 105.251 7.05585 104.668 6.96321L102.444 6.56179Z",
    fill: "url(#paint4_linear_1_407)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M132.689 8.29103L132.014 9.10932C132.401 8.93563 132.823 8.80054 133.272 8.7079C133.72 8.61526 134.207 8.56894 134.729 8.56894C135.557 8.56894 136.366 8.7079 137.152 8.98581C137.938 9.26372 138.64 9.68059 139.253 10.2364C139.866 10.7922 140.361 11.4909 140.733 12.3285C141.105 13.1661 141.293 14.1542 141.293 15.2851C141.293 16.3234 141.101 17.3077 140.718 18.2341C140.334 19.1605 139.794 19.9672 139.092 20.6581C138.39 21.349 137.554 21.8932 136.577 22.2947C135.599 22.6961 134.514 22.8968 133.318 22.8968C132.102 22.8968 131.013 22.7038 130.051 22.3178C129.088 21.9318 128.272 21.3876 127.597 20.689C126.922 19.9903 126.404 19.1527 126.048 18.18C125.691 17.2073 125.511 16.1343 125.511 14.9609C125.511 13.8801 125.722 12.7839 126.147 11.6723C126.573 10.5606 127.217 9.41811 128.088 8.24471L133.256 1.23517C133.459 0.968836 133.762 0.737248 134.161 0.540394C134.56 0.343541 135.016 0.24704 135.526 0.24704H139.284L132.689 8.29103ZM133.241 19.4692C133.793 19.4692 134.303 19.3727 134.775 19.1759C135.246 18.979 135.649 18.7088 135.986 18.3576C136.324 18.0064 136.588 17.5972 136.784 17.1301C136.979 16.6631 137.075 16.1497 137.075 15.5939C137.075 14.9879 136.983 14.4398 136.799 13.9573C136.615 13.4748 136.354 13.0657 136.017 12.7299C135.679 12.3941 135.277 12.1393 134.805 11.9656C134.334 11.7919 133.812 11.7032 133.241 11.7032C132.7 11.7032 132.202 11.7997 131.753 11.9888C131.305 12.1779 130.917 12.4481 130.595 12.7916C130.273 13.1352 130.024 13.5443 129.844 14.0191C129.664 14.4939 129.575 15.0111 129.575 15.5785C129.575 16.1652 129.652 16.6979 129.805 17.1765C129.959 17.6551 130.189 18.0642 130.496 18.4039C130.802 18.7436 131.182 19.0061 131.638 19.1913C132.094 19.3766 132.627 19.4692 133.241 19.4692Z",
    fill: "url(#paint5_linear_1_407)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M155.261 8.2756C155.721 8.18296 156.162 8.11733 156.588 8.07488C157.013 8.03242 157.423 8.01312 157.822 8.01312C158.988 8.01312 160.019 8.19067 160.913 8.54578C161.806 8.90089 162.558 9.38723 163.167 10.0048C163.777 10.6224 164.233 11.3481 164.54 12.1818C164.847 13.0155 165 13.911 165 14.8683C165 16.061 164.789 17.1495 164.371 18.1337C163.953 19.118 163.37 19.9594 162.63 20.6658C161.89 21.3722 161.005 21.9203 159.977 22.3101C158.95 22.7 157.826 22.8968 156.611 22.8968C155.905 22.8968 155.23 22.8235 154.586 22.6729C153.942 22.5224 153.34 22.3217 152.784 22.0708C152.228 21.8199 151.707 21.5266 151.227 21.1985C150.748 20.8704 150.319 20.523 149.939 20.164L151.243 18.373C151.519 17.9909 151.875 17.8018 152.316 17.8018C152.592 17.8018 152.865 17.8828 153.129 18.0488C153.394 18.2148 153.697 18.3962 154.034 18.5969C154.371 18.7976 154.766 18.979 155.215 19.145C155.664 19.311 156.212 19.392 156.856 19.392C157.519 19.392 158.098 19.2801 158.589 19.0601C159.08 18.8401 159.486 18.5352 159.808 18.1492C160.13 17.7632 160.372 17.3039 160.529 16.775C160.686 16.2462 160.767 15.675 160.767 15.069C160.767 13.9072 160.437 13.0078 159.778 12.3748C159.118 11.7418 158.16 11.4252 156.902 11.4252C155.871 11.4252 154.831 11.6221 153.789 12.012L151.166 11.2709L153.037 0.24704H164.202V2.03803C164.202 2.33524 164.16 2.60542 164.072 2.84859C163.984 3.09177 163.842 3.30021 163.643 3.48162C163.443 3.66304 163.186 3.80199 162.876 3.89848C162.565 3.99498 162.182 4.04516 161.733 4.04516H155.982L155.261 8.2756Z",
    fill: "url(#paint6_linear_1_407)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_407",
    x1: 9.53195,
    y1: 22.6483,
    x2: 9.53195,
    y2: 0.245535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    stopColor: "#135E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#18649F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3595,
    stopColor: "#5CC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#3B9FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6729,
    stopColor: "#1F8195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8323,
    stopColor: "#239594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_407",
    x1: 36.041,
    y1: 22.6483,
    x2: 36.041,
    y2: 0.245535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    stopColor: "#135E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#18649F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3595,
    stopColor: "#5CC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#3B9FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6729,
    stopColor: "#1F8195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8323,
    stopColor: "#239594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_407",
    x1: 59.8595,
    y1: 22.6483,
    x2: 59.8595,
    y2: 0.245535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    stopColor: "#135E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#18649F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3595,
    stopColor: "#5CC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#3B9FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6729,
    stopColor: "#1F8195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8323,
    stopColor: "#239594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_407",
    x1: 82.0684,
    y1: 22.8951,
    x2: 82.0684,
    y2: -0.0013893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    stopColor: "#135E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#18649F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3595,
    stopColor: "#5CC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#3B9FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6729,
    stopColor: "#1F8195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8323,
    stopColor: "#239594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_407",
    x1: 109.599,
    y1: 22.8951,
    x2: 109.599,
    y2: -0.0013893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3153,
    stopColor: "#1F8195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    stopColor: "#239594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6405,
    stopColor: "#26A593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_407",
    x1: 133.403,
    y1: 22.8952,
    x2: 133.403,
    y2: 0.245535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3153,
    stopColor: "#1F8195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    stopColor: "#239594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6405,
    stopColor: "#26A593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_407",
    x1: 157.468,
    y1: 22.8952,
    x2: 157.468,
    y2: 0.245535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3153,
    stopColor: "#1F8195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    stopColor: "#239594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6405,
    stopColor: "#26A593"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamedLogo);
export default __webpack_public_path__ + "static/media/named_logo.ac357836148d371f7318ab2ef6841189.svg";
export { ForwardRef as ReactComponent };